export const locale = {
  lang: 'sp',
  data: {
    PRONOSTICO: {
      PRONOSTICO_SUCCESS: 'Éxito',
      PRONOSTICO_ERROR: 'Error',
      PRONOSTICO_COMMUNICATION_ERROR: 'Error de comunicación'
    }
  }
}